(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-coverage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePressCoverage = (root) => {
      if (!root || root.dataset.pressCoverageReady === 'true') return;

      root.dataset.pressCoverageReady = 'true';

      const marquee = root.querySelector('.press-featured-marquee');
      const featuredList = root.querySelector('.press-featured:not(.press-featured--clone)');
      const featuredControls = root.querySelector('[data-press-featured-controls]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (marquee && featuredList && featuredControls) {
        const featuredCards = Array.from(featuredList.querySelectorAll('.press-card--featured'));
        const previousButton = featuredControls.querySelector('[data-press-featured-previous]');
        const nextButton = featuredControls.querySelector('[data-press-featured-next]');
        const dots = Array.from(featuredControls.querySelectorAll('[data-press-featured-dot]'));
        const status = featuredControls.querySelector('[data-press-featured-status]');
        let activeIndex = 0;
        let scrollFrame;

        const updateFeaturedState = (index) => {
          const nextIndex = Math.max(0, Math.min(index, featuredCards.length - 1));

          if (nextIndex === activeIndex && status.textContent.trim() === `Featured story ${nextIndex + 1} of ${featuredCards.length}`) {
            return;
          }

          activeIndex = nextIndex;
          previousButton.disabled = activeIndex === 0;
          nextButton.disabled = activeIndex === featuredCards.length - 1;

          dots.forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === activeIndex);
          });

          status.textContent = `Featured story ${activeIndex + 1} of ${featuredCards.length}`;
        };

        const getCardPosition = (card) => card.offsetLeft - featuredCards[0].offsetLeft;

        const syncFeaturedState = () => {
          scrollFrame = undefined;

          const nearestIndex = featuredCards.reduce((nearest, card, index) => {
            const nearestDistance = Math.abs(getCardPosition(featuredCards[nearest]) - marquee.scrollLeft);
            const cardDistance = Math.abs(getCardPosition(card) - marquee.scrollLeft);

            return cardDistance < nearestDistance ? index : nearest;
          }, 0);

          updateFeaturedState(nearestIndex);
        };

        const scrollToFeaturedCard = (index) => {
          const nextIndex = Math.max(0, Math.min(index, featuredCards.length - 1));

          marquee.scrollTo({
            left: getCardPosition(featuredCards[nextIndex]),
            behavior: reduceMotion ? 'auto' : 'smooth'
          });

          updateFeaturedState(nextIndex);
        };

        previousButton.addEventListener('click', () => {
          scrollToFeaturedCard(activeIndex - 1);
        });

        nextButton.addEventListener('click', () => {
          scrollToFeaturedCard(activeIndex + 1);
        });

        marquee.addEventListener('scroll', () => {
          if (scrollFrame) return;

          scrollFrame = window.requestAnimationFrame(syncFeaturedState);
        }, { passive: true });

        updateFeaturedState(0);
      }

      const buttons = Array.from(root.querySelectorAll('[data-press-filter]'));
      const cards = Array.from(root.querySelectorAll('[data-press-card]'));

      if (!buttons.length || !cards.length) return;

      const applyFilter = (filter) => {
        buttons.forEach((button) => {
          const isActive = button.dataset.pressFilter === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        cards.forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.category !== filter;
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const update = () => applyFilter(button.dataset.pressFilter);

          if (document.startViewTransition && !reduceMotion) {
            document.startViewTransition(update);
          } else {
            update();
          }
        });
      });
    };

    document.querySelectorAll('[data-press-coverage]').forEach(initializePressCoverage);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-press-coverage]')
        ? event.target
        : event.target.querySelector('[data-press-coverage]');

      initializePressCoverage(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
